import { Card as BsCard } from 'react-bootstrap';
import { isEmpty, truncate } from 'lodash';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Badges } from './Badges';

const Card = ({
  title,
  previewImage,
  previewText,
  url,
  target,
  badgeText,
  badges,
  tenant,
  dateString,
}) => (
  <a
    className="h-100 d-block text-reset text-decoration-none card-badge__container image-hover"
    href={url}
    target={target || '_self'}
  >
    <BsCard className="h-100 overflow-hidden">
      <div className="overflow-hidden">
        <BsCard.Img
          loading="lazy"
          variant="top"
          src={previewImage.url}
          width={previewImage.width}
          height={previewImage.height}
          alt={previewImage.alt}
        />
      </div>
      <BsCard.Body className="d-flex flex-column gap-2">
        <h3>{title}</h3>
        <p>
          <i className="fa-regular fa-location-dot me-1" />
          {tenant}
        </p>
        {dateString && (
          <p>
            <i className="fas fa-calendar-alt text-primary icon__before-text" />
            {dateString}
          </p>
        )}
        {parse(truncate(previewText, { length: 200, separator: ' ' }))}
      </BsCard.Body>
    </BsCard>
    {!isEmpty(badges) && <Badges badges={badges} />}
    {isEmpty(badges) && badgeText && (
      <div className="card-badge__badge">{badgeText}</div>
    )}
  </a>
);

export { Card };

Card.propTypes = {
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string,
  }),
  previewText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  target: PropTypes.string,
  badgeText: PropTypes.string,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      badgeIcon: PropTypes.string,
      badgeColour: PropTypes.string,
      badgeTextColour: PropTypes.string,
    })
  ),
  tenant: PropTypes.string,
  dateString: PropTypes.string,
};
